// The words around reporting and blocking, kept pure (no Nuxt imports) so they
// are tested directly. Mirrored by the app's safety_copy.dart: change both.

/**
 * Shown in the report dialog when the server could not say who will read the
 * report. The server's own line names the club or the Tap Leagues team.
 */
export const REPORT_AUDIENCE_FALLBACK =
    "Your report and the reported messages will be seen by this club's admins, or by the Tap Leagues team for a direct message.";

/**
 * The line above the report form: the server's answer from
 * GET contentReports/audience (it knows whether anyone at the club can review
 * this message), or the fallback when that did not arrive.
 */
export const reportAudienceLine = (audience) => {
    const line = audience?.line?.trim();
    return line || REPORT_AUDIENCE_FALLBACK;
};

/**
 * What a block does, said before it happens (owner finding, 24 Sep 2026: a
 * block hid "a lot of messages" and nothing had said which or where).
 */
export const blockConfirmation = (name) => {
    const who = (name || '').trim() || 'this player';
    return {
        title: `Block ${who}?`,
        body: `${who === 'this player' ? 'This player' : who}'s messages will be hidden from you in every chat you share, `
            + `club and group chats included, not just this one. Neither of you can message the other directly, `
            + `and they aren't told. Unblock them from Blocked users on your profile and their messages come back.`,
        confirm: 'Block',
    };
};
